<template>
  <div class="evaluation-card">
    <div class="evaluation-card__header">
      <slot name="leading" />
      <div class="evaluation-card__title">
        <slot name="title" />
      </div>
      <div class="evaluation-card__actions">
        <slot name="actions" />
      </div>
    </div>
    <div class="evaluation-card__body">
      <div class="evaluation-card__columns">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.evaluation-card {
  border: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: 4px !important;
  background: rgb(var(--v-theme-off-white));
  overflow: hidden;
  box-shadow:
    0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)),
    0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)),
    0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}

.evaluation-card__header {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 52px;
  padding: 4px 16px;
  background: rgb(var(--v-theme-primary-lighten-5));
  border-radius: 4px 4px 0 0;
}

.evaluation-card__title {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  color: rgb(var(--v-theme-primary-darken-2));
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evaluation-card__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.evaluation-card__body {
  padding: 16px;
}

.evaluation-card__columns {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 32px;
  align-items: start;
}

@media (max-width: 960px) {
  .evaluation-card__columns {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
